export const getWindowLocationPathname = () =>
  window?.location?.pathname ?? 'UnknownScreen';
